import SwiperCore, { Swiper, Mousewheel } from 'swiper/core';

SwiperCore.use(Mousewheel);

const storySliderEl = document.querySelectorAll('.c-slider--story');

if (storySliderEl) {
  storySliderEl.forEach(slider => {
    const storySlider = new Swiper(slider, {
      mousewheel: true,
      init: false,
      slidesPerView: 'auto',
      spaceBetween: 16,
    });

    storySlider.init();
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/storySlider.js